var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E7B46D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9506 20.837C23.9506 20.837 22.9065 18.052 20.0359 18.052C17.1653 18.052 14.9426 20.7074 16.1212 25.0476C17.2973 29.3878 23.953 32.9895 23.953 32.9895",
    stroke: "white",
    strokeWidth: 0.978063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9517 20.837C23.9517 20.837 24.9957 18.052 27.8664 18.052C30.737 18.052 32.9596 20.7074 31.7811 25.0476C30.6049 29.3878 23.9492 32.9895 23.9492 32.9895",
    stroke: "white",
    strokeWidth: 0.978063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4899 37.3467L24.2153 43.511L13.4762 37.3345C12.2463 36.6278 11.4883 35.3172 11.4883 33.899V11.2642L24.3474 9.48901L36.4142 11.2642V33.9479C36.4142 35.3392 35.6831 36.6303 34.4899 37.3467Z",
    stroke: "white",
    strokeWidth: 0.978063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.904,
    height: 35,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/LI.b5b2e3ffc7a1d7e2837b321a0fe65eec.svg";
export { ForwardRef as ReactComponent };